import { Box, Stack, Text } from '@chakra-ui/react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useEffect, useMemo, useState } from 'react';
import { getDocTypeData } from '../../services/DocumentTypes.js';
import GeneralDocumentTypes from './GeneralDocTypes.js';
import _ from 'lodash';
import MyTabsNested from '../../components/MyTabsNested.js';
import Section1 from './Section1.js';
import { setPreview } from '../../redux/actions/previewActions.js';
import { useDispatch } from 'react-redux';

const EditDocTypesRecord = () => {

  const { alias } = useParams();
  const [docTypeTitle, setDocTypeTitle] = useState();
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const tabs = useMemo(() => [
    {
      id: "general", title: "General", Component: GeneralDocumentTypes, subTabs: [
        { id: "basic", title: "Basic", Component: Section1 }
      ]
    }
  ], []);

  useEffect(() => {
    const getBasicData = async () => {
      try {
        if (alias) {
          const result = await getDocTypeData(alias);

          if (result) {
            setDocTypeTitle(result?.data?.[0]?.name || result?.data?.[0]?.alias);
          }
        }
      } catch (error) {
        console.error('Error fetching DocTypes data:', error);
      }
    };

    getBasicData();
    dispatch(setPreview(false))
  }, [alias, dispatch]);

  // Redirect to default tab if no tab is specified
  useEffect(() => {
    const pathParts = location.pathname.split('/');
    if (pathParts?.length === 3 && alias) {
      // Redirect to the default tab/subTab
      navigate(`/document-types/${alias}/${tabs[0].id}/${tabs?.[0].subTabs?.[0].id}`, { replace: true });
    }
  }, [location.pathname, alias, navigate, tabs]);

  return (
    <Stack py="5px">
      <Box px="4" pb="4">
        <Text fontSize={"22px"} fontWeight={"600"}>{_.capitalize(docTypeTitle)}</Text>
      </Box>
      <MyTabsNested orientation="vertical" list={tabs} urlBasePath={"/document-types"} />
    </Stack>
  );
};

export default EditDocTypesRecord;